module.exports = __webpack_public_path__ + "static/media/facebook.c46f1d15.svg";